// If colors are changed here, please also update the main.scss!

export default {
  light: {
    primary: {
      base: '#59CBE8',
      darken1: '#0095BB',
      darken2: '#37768C',
      darken3: '#006e8a',
      desaturate1: '#7ab0be',
    },
    secondary: {
      base: '#59CBE8',
    },
    accent: {
      base: '#0095BB',
    },
    error: {
      base: '#DE2020',
      lighten1: '#ff3d3d',
    },
    info: {
      base: '#59CBE8',
    },
    success: {
      base: '#50EF71',
    },
    warning: {
      base: '#FFCA4C',
      lighten1: '#F9FF00',
    },
    grey: {
      base: '#819ea8',
    },
  },
}
